import { computed, inject, Injectable, signal } from '@angular/core'
import { LIB_STAGE } from '../provider'

@Injectable()
export class StageService {
  readonly stage = inject(LIB_STAGE)
  readonly isProd = computed(() => this.stage === 'env-production')
  readonly hideStageBanner = signal(false)
  /** Ob `lib-stage-bar` gerade etwas rendert — die Navigation zieht dann seine Hoehe von ihren Flaechen ab. */
  readonly showStageBanner = computed(() => !this.isProd() && !this.hideStageBanner())
}
